const transformString = (str) => str?.toLowerCase()?.trim() || null;

export default transformString;
